module.exports = __webpack_public_path__ + "static/media/38.490aa1f2.mp3";